import React from "react";
import classnames from "classnames";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import ToolTip from "../tool-tip";
import IconSaveForLater from "./icon-save-for-later";
import IconTags from "./icon-tags";
import IconCollection from "./icon-collection";
import LicenseStrip from "./license-strip";

const PhaseInitial = props => {
    return (
        <div>
            <IconCollection {...props} />
            <LicenseStrip
                license={props.download.iconBaseLicense}
                icon={props.download.pendingDownload}
            />
            <div className="download-actions">
                <IconDownload {...props} />
                <IconSaveForLater {...props} />
            </div>
            <IconTags {...props} />
        </div>
    );
};

export default PhaseInitial;

const IconDownload = props => {
    let { download } = props;

    return (
        <button
            className="button green download-flow-start-button"
            onClick={props.downloadRequest.bind(null, null)}
        >
            Get this icon
        </button>
    );
};
